// extracted by mini-css-extract-plugin
module.exports = {"heading":"views-Epochs__heading--3TfZM"};